export default window._cmsContent['whd/error-screen']